import { z } from 'zod';

const registryFileTypeSchema = z.enum(['registry:component', 'registry:file']);
const registryItemTypeSchema = z.literal('registry:component');
const categorySchema = z.enum(['ui', 'example']);

export const registryFileSchema = z
  .object({
    path: z.string(),
    type: registryFileTypeSchema,
    target: z.string().optional(),
    encoding: z.string().optional(),
    content: z.string().optional(),
  })
  .superRefine((value, ctx) => {
    if (value.type === 'registry:file' && !value.target) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'registry:file entries must specify a target path',
        path: ['target'],
      });
    }
  });

export const registryItemSchema = z.object({
  name: z.string(),
  type: registryItemTypeSchema,
  description: z.string(),
  files: z.array(registryFileSchema),
  category: categorySchema,
  registryDependencies: z.array(z.string()).optional(),
});

export const registrySchema = z.object({
  name: z.string(),
  items: z.array(registryItemSchema),
});

export type RegistryFile = z.infer<typeof registryFileSchema>;
export type RegistryItem = z.infer<typeof registryItemSchema>;
export type Registry = z.infer<typeof registrySchema>;
